import { toast } from "react-toastify";
import { handleGet } from "./controller.all";
import { Send } from "../services/service.api";



export async function sendPushNotification(title = "KalanYoro", body = "Notification", expoPushToken, token) {
    if(!expoPushToken) return;
    
    const message = {
        expoPushToken: expoPushToken,
        title: title,
        body: body,
        data: { someData: 'goes here' },
    };

    try {
        await Send("/info/push", message, true, token);
        toast.success("Notification envoyée");
    } catch (e) {
        console.error("Erreur push", e);
    }
}


export async function SendMessage(data, token){
    
    try {
        const res = await Send("/twilio/message", data, true, token);
        if (res && res.state === "success") {
            toast.success("Message envoyé");
            return true;
        } else {
            toast.warn("Le message n'a pas pu être envoyé");
        }
    } catch (error) {
        toast.error("Erreur, impossible d'envoyer le message");
    }
}



export async function sendNotificationToClass(classId, title, message, usePush, useSms, includeTuteurs, token, ecoleId) {
    if (!classId) {
        toast.error("Veuillez sélectionner une classe.");
        return false;
    }
    if (!title || !message) {
        toast.error("Le titre et le message sont requis.");
        return false;
    }

    try {
        let students = [];
        await handleGet(`/user/s/all/eleves/${ecoleId}`, (res) => {
            if (res?.users) {
                students = res.users.filter(u => u.classe?._id === classId || u.classe === classId);
            }
        }, token);

        if (students.length === 0) {
            toast.warn("Aucun étudiant trouvé dans cette classe.");
            return false;
        }

        for (const student of students) {
            // Push Notification
            if (usePush && student.expo_token) {
                await sendPushNotification(title, message, student.expo_token, token);
            }

            // SMS for Student
            if (useSms && student.tel) {
                try {
                    await SendMessage({
                        to: student.tel,
                        message: `${title}: ${message}`,
                        code: 'KALANYORO2026'
                    }, token);
                    toast.success("SMS étudiant envoyé");
                } catch (e) {
                    console.error("Erreur SMS étudiant", e);
                }
            }

            // SMS for Tuteur
            if (useSms && includeTuteurs) {
                // Determine tuteur phone from common property names
                const tuteurPhone = student.tuteur?.tel || student.numero_tuteur || student.tel_tuteur || student.tuteur_tel || student.parent_tel;
                if (tuteurPhone) {
                    try {
                        await SendMessage({
                            to: tuteurPhone,
                            message: `Message concernant ${student.prenom} ${student.nom} - ${title}: ${message}`,
                            code: 'KALANYORO2026'
                        }, token);
                        toast.success("SMS tuteur envoyé");
                    } catch (e) {
                        console.error("Erreur SMS tuteur", e);
                    }
                }
            }
        }

        //toast.success(`Opération terminée : ${pushCount} Push, ${smsCount} SMS envoyés.`);
        toast.success("Notifications envoyées avec succès !");
        return true;
    } catch (e) {
        console.error(e);
        toast.error("Erreur lors de l'envoi.");
        return false;
    }
}

export async function sendNotificationToAdmin(ecoleId, title, message, usePush, useSms, token) {
    if (!ecoleId) {
        toast.error("Veuillez sélectionner une école.");
        return false;
    }
    if (!title || !message) {
        toast.error("Le titre et le message sont requis.");
        return false;
    }

    try {
        let admins = [];
        await handleGet(`/user/s/all`, (res) => {
            if (res?.users) {
                admins = res.users.filter(u => u.role === "ADMIN");
                if (ecoleId !== "ALL") {
                    admins = admins.filter(u => 
                        (u.ecole?._id === ecoleId || u.ecole === ecoleId) || 
                        (u.ecoles && u.ecoles.some(e => e._id === ecoleId || e === ecoleId))
                    );
                }
            }
        }, token);

        if (admins.length === 0) {
            toast.warn("Aucun administrateur trouvé pour cette sélection.");
            return false;
        }

        let smsSent = 0;
        let pushSent = 0;

        for (const admin of admins) {
            if (usePush && admin.expo_token) {
                try {
                    await sendPushNotification(title, message, admin.expo_token, token);
                    pushSent++;
                } catch (error) {
                    console.error("Erreur Push admin", error);
                }
            }

            if (useSms && admin.tel) {
                try {
                    await SendMessage({
                        to: admin.tel,
                        message: `${title}: ${message}`,
                        code: 'KALANYORO2026'
                    }, token);
                    smsSent++;
                } catch (e) {
                    console.error("Erreur SMS admin", e);
                }
            }
        }

        
        
        if (useSms && smsSent > 0) toast.success(`${smsSent} SMS envoyé(s)`);
        if (usePush && pushSent > 0) toast.success(`${pushSent} Push envoyé(s)`);
        if (smsSent === 0 && pushSent === 0) toast.warn("Aucun message n'a pu être envoyé (aucun numéro ou token)");
        
        return true;
    } catch (e) {
        console.error(e);
        toast.error("Erreur lors de l'envoi.");
        return false;
    }
}
